import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Heading from '../Heading';
import Sidebar from '../../containers/Sidebar';
import StoreName from './StoreName';

import styles from './index.module.css';

const Layout = ({ heading, children, sideAction, sideContent }) => {
  const env = process.env.REACT_APP_ENV || 'local';

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
    return () => window.dispatchEvent(new Event('resize'));
  }, []);

  return (
    <div className={styles.layout} id="layout">
      <aside className={styles.sidebar}>
        <Sidebar />
      </aside>
      <article
        className={classNames(styles.content, {
          [styles['content-production']]: env === 'production',
        })}
        data-test="layout-content"
      >
        <div className={styles.header}>
          <div className={styles.sideAction}>{sideAction}</div>
          {heading && (
            <div className={styles.headerContent}>
              <div className={styles.storeName} data-test="storeName">
                <StoreName />
              </div>
              <Heading level="1" size="1" weight="medium" color="blue">
                {heading}
              </Heading>
            </div>
          )}
          {sideContent && (
            <div className={styles.sideContent}>{sideContent}</div>
          )}
        </div>
        <div className={styles.main}>{children}</div>
      </article>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  sideAction: PropTypes.element,
  sideContent: PropTypes.node,
};

Layout.defaultProps = {
  heading: null,
};

export default Layout;
